/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsListSuiteLeaderboardRuns } from "../../funcs/llmEvalsListSuiteLeaderboardRuns.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEvalSuiteLeaderboardRunsRequest$inboundSchema,
};

export const tool$llmEvalsListSuiteLeaderboardRuns: ToolDefinition<
  typeof args
> = {
  name: "llm-evals-list-suite-leaderboard-runs",
  description: `List leaderboard runs for an eval suite

Returns each ranking group's most recent completed runs for a suite in one request, with the group assignments in \`groups\`. A group is (model, targeted task) for task_ids-restricted runs and (model) for unrestricted runs (task_id null). Build boards from \`groups\`, not from run.models/run.task_ids — a returned run may name models or tasks whose groups it did not rank in. \`truncated: true\` means a server ceiling trimmed the aggregate; whole runs are kept in (best rank, first model, first task, id) order, so every group's newest runs survive before any group's fallbacks and no group is dropped for being old. Resume a truncated board by passing \`next_cursor\` back as \`cursor\` and unioning the responses. See the evals docs for grouping rationale and cost characteristics.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsListSuiteLeaderboardRuns(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
